import { DateWindow } from './DateWindow';
import { DateTrunc } from '../../../models';
import { createRelativeWindow } from '../types/latestDataDateWindow';
import { createLastNWindow } from '../types/lastNDateWindow';
import { ALL_TIME_DATE_WINDOW } from '../types/allTimeDateWindow';

export const defaultDateWindow = (dateTrunc?: DateTrunc): DateWindow => {
  switch (dateTrunc) {
    case DateTrunc.SECOND: {
      return createRelativeWindow({
        unit: DateTrunc.MINUTE,
        numberOfUnits: 3,
      });
    }
    case DateTrunc.MINUTE: {
      return createRelativeWindow({
        unit: DateTrunc.HOUR,
        numberOfUnits: 3,
      });
    }
    case DateTrunc.HOUR: {
      return createRelativeWindow({
        unit: DateTrunc.DAY,
        numberOfUnits: 7,
      });
    }
    case DateTrunc.ISO_WEEKDAY:
    case DateTrunc.DAY: {
      return createRelativeWindow({
        unit: DateTrunc.DAY,
        numberOfUnits: 90,
      });
    }
    case DateTrunc.MONTH: {
      return createRelativeWindow({
        unit: DateTrunc.MONTH,
        numberOfUnits: 12,
      });
    }
    case DateTrunc.ISO_WEEK:
    case DateTrunc.WEEK: {
      return createRelativeWindow({
        unit: DateTrunc.WEEK,
        numberOfUnits: 52,
      });
    }
    case DateTrunc.ISO_QTR:
    case DateTrunc.QUARTER: {
      return createRelativeWindow({
        unit: DateTrunc.QUARTER,
        numberOfUnits: 8,
      });
    }
    case DateTrunc.ISO_YEAR:
    case DateTrunc.YEAR: {
      return createRelativeWindow({
        unit: DateTrunc.YEAR,
        numberOfUnits: 5,
      });
    }
    case DateTrunc.NONE: {
      return ALL_TIME_DATE_WINDOW;
    }
    case DateTrunc.UNKNOWN:
    case undefined:
    default: {
      return createLastNWindow(100);
    }
  }
};
